// useSubtitleChecker.js
import axios from 'axios';
import authHeader from '@/services/auth-header';

export function useSubtitleChecker() {
    const extensions = [".vtt", ".srt", ".smi"];

    const checkSubtitleExists = async (file, sync) => {
        const baseName = file.replace(/\.[^/.]+$/, "");

        for (const ext of extensions) {
            let subtitleUrl =
                process.env.VUE_APP_API_URL +
                `file/smi/${baseName}${ext}?sync=${sync}`;

            subtitleUrl = normalizeUrlSlashes(subtitleUrl);

            try {
                const response = await axios.get(subtitleUrl, {
                    headers: {
                        ...authHeader(),
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                    responseType: 'blob',
                });

                if (response.status === 200) {
                    return {
                        url: URL.createObjectURL(response.data),
                        name: `${baseName}${ext}`, // ← 추가
                        ext: ext                  // ← optional
                    };
                }
            } catch (err) { }
        }

        return false;
    };

    const getSubtitle = async (file, sync) => {
        const baseName = file.replace(/\.[^/.]+$/, "");
        const ext = file.split('.').pop().toLowerCase();

        let subtitleUrl =
            process.env.VUE_APP_API_URL +
            `file/smi/${baseName}.${ext}?sync=${sync}`;

        subtitleUrl = normalizeUrlSlashes(subtitleUrl);

        try {
            const response = await axios.get(subtitleUrl, {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                responseType: 'blob',
            });

            if (response.status === 200) {
                return {
                    url: URL.createObjectURL(response.data),
                    name: `${baseName}.${ext}`,
                    ext: ext
                };
            }
        } catch (err) { }

        return false;
    };

    return { checkSubtitleExists, getSubtitle };
}

function normalizeUrlSlashes(url) {
    const parts = url.split('://'); // ['https', 'example.com//api///smi']
    const protocol = parts[0];
    const path = parts[1].replace(/\/{2,}/g, '/'); // 슬래시 정리
    return `${protocol}://${path}`;
}